export default __webpack_public_path__ + "static/media/twitter-shared.36bdc0db.png";